import { action, asyncAction } from '@play-co/replicant';
import createActions from 'src/replicant/config/actions/createActions';
import { getEndedLeagues, getUnclaimedLeagues } from './leagues.getters';
import { claimLeagueRewards, joinLeague } from './leagues.modifiers';

export const leaguesActions = createActions({
  /**
   * Join league.
   */
  joinLeague: action((state, _, api) => {
    return joinLeague(state, api.date.now());
  }),

  /**
   * Set final rank for each league.
   */
  endLeagueEvents: asyncAction(async (state, _, api) => {
    // Get ended leagues.
    const endedLeagues = getEndedLeagues(state);

    // Set final rank for each league.
    for (const leagueId of endedLeagues) {
      const scoreboard = await api.asyncGetters.getLeagueScoreboard({
        leagueId,
        friendsOnly: false,
      });
      state.match2.leagues[leagueId].finalRank = scoreboard.playerRank;
    }
  }),

  /**
   * Claim rewards for leagues.
   */
  claimLeagueRewards: action((state, _, api) => {
    // Get unclaimed leagues.
    const unclaimedLeagues = getUnclaimedLeagues(state);

    // Return if no leagues to claim.
    if (!unclaimedLeagues.length) return;

    // Claim rewards for each league.
    for (const leagueId of unclaimedLeagues) {
      claimLeagueRewards(state, leagueId, api);
    }
  }),
});
